import { useStaticQuery, graphql } from "gatsby"

// only one query per file, so we put each url in its own file

export const useSubscriptionPageUrl = () => {
  const data = useStaticQuery(subscriptionPageUrlQuery)
  return (data.pssHeaderLink || {}).url
}

const subscriptionPageUrlQuery = graphql`
  query SubscriptionPageUrlQuery {
    pssHeaderLink(key: { eq: "subscriptionPageUrl" }) {
      url
    }
  }
`
